import { render, staticRenderFns } from "./LcsjgModal.vue?vue&type=template&id=4070def5&scoped=true&"
import script from "./LcsjgModal.vue?vue&type=script&lang=js&"
export * from "./LcsjgModal.vue?vue&type=script&lang=js&"
import style0 from "./LcsjgModal.vue?vue&type=style&index=0&id=4070def5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4070def5",
  null
  
)

export default component.exports